<div class="setting-container">
  <div class="setting-nav-bar box">
    <div class="setting-nav-bar-title">تنظیمات</div>
    <div class="setting-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="setting-holder box">
    <div class="box app-setting-table">
      <app-personal-info></app-personal-info>
      <app-tribune-setting></app-tribune-setting>
      <div class="box profile-table" (click)="settingSelected('support')">
        <div class="profile-cell box profile-cell-btn">
          <div class="profile-cell-button profile-cell-button--blue">
            پشتیبانی
          </div>
        </div>
      </div>
      <div class="box profile-table last-button">
        <div
          class="profile-cell box profile-cell-btn"
          (click)="settingSelected('logout')"
        >
          <div class="profile-cell-button profile-cell-button--red">
            خروج از حساب کاربری
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-edit-bottomsheet
    *ngIf="showEdit"
    [type]="selectedType"
    [user]="user"
    [blogUser]="blogUser"
  ></app-edit-bottomsheet>
</div>
